<template>
  <div class="text-center row">
    <img src="~@assets/img/loader-black.svg" />
  </div>
</template>

<script>
export default {}
</script>